module.exports = __webpack_public_path__ + "static/elevate_crm.ee7275c6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/elevate_crm.gif
// module id = 3083
// module chunks = 213231404188204